export default function() {
    const self = this

    self.$store.dispatch('storeUserInfo')
}